import { NotificationsConfirm } from 'gu-ui-kit'
import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import React from 'react'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import PropTypes from 'prop-types'

export const EmailDisapproved = ({ isEmailConfirmed }) => {
  const pathGen = useGeneratePathI18n()
  const { t } = useTranslation()

  if (typeof isEmailConfirmed === 'boolean' && isEmailConfirmed === true) {
    return null
  }

  return (
    <NotificationsConfirm
      className={'margin-bottom-40'}
      variant={'error'}
      title={t('billing::email_disapproved_message.heading')}
      CloseButton={false}
      description={
        <div>
          <Trans i18nKey="billing::email_disapproved_message.description">
            Чтобы создать платежный профиль, подтвердите свой email в
            <Link to={pathGen(ROUTES.USER_SETTINGS)}>личном кабинете</Link>
          </Trans>
        </div>
      }
    />
  )
}

EmailDisapproved.propTypes = {
  isEmailConfirmed: PropTypes.bool,
}
